import { useCallback, useEffect, useState } from 'react';
import { countPendingOfflineSales } from '../offline/posOfflineStore';

export type NetworkStatus = {
  isOnline: boolean;
  pendingOfflineCount: number;
  refreshPendingCount: () => Promise<void>;
};

export function useNetworkStatus(): NetworkStatus {
  const [isOnline, setIsOnline] = useState(
    typeof navigator !== 'undefined' ? navigator.onLine : true,
  );
  const [pendingOfflineCount, setPendingOfflineCount] = useState(0);

  const refreshPendingCount = useCallback(async () => {
    try {
      const n = await countPendingOfflineSales();
      setPendingOfflineCount(n);
    } catch {
      setPendingOfflineCount(0);
    }
  }, []);

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);
    window.addEventListener('online', onOnline);
    window.addEventListener('offline', onOffline);
    void refreshPendingCount();
    return () => {
      window.removeEventListener('online', onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, [refreshPendingCount]);

  return { isOnline, pendingOfflineCount, refreshPendingCount };
}
